import React, { useState, useEffect, useRef } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import {
    getReportTemplateParameter,
    createNewReport,
    updateReport,
    getUpdatedCustomerReportData,
    updateNiptDob,
    createNiptDob,
} from "../../../actions/LimsAdminActions";
import { useNavigate, useParams } from "react-router-dom";
import ReactToPrint from "react-to-print";
import QRCode from "react-qr-code";
import nabllogo from "../../../../NABL Logo.png";
import mra from "../../../../mra.png";
import "./style.css";
import logo from "../../../../redcliffe_logo.jpeg";
import callIcon from "../../../../callicon.png";
import maillIcon from "../../../../mailicon.png";
import browserIcon from "../../../../browsericon.png";
import { Paper } from "@mui/material";
import Grid from '@mui/material/Grid';
import { Select, MenuItem, TextField } from '@material-ui/core';
import moment from "moment";
import Graph from "./QfGRAPh.png"
import { green } from "@mui/material/colors";
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import NpsRating from "../../NPS";
import { Grammarly, GrammarlyEditorPlugin } from "@grammarly/editor-sdk-react";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const useStyles = makeStyles((theme) =>
    createStyles({
        paper: {
            width: "100%",
        },
        centerIt: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        fontWeight: {
            fontWeight: "bold",
        },
        textCenter: {
            textAlign: "center",
        },
        endIt: {
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
        },
        belowIt: {
            display: "flex",
            alignItems: "flex-end",
        },
        line: {
            borderBottom: "5px solid red",
            marginTop: "5px",
            width: "90%",
        },
        inputFiled: {
            outline: "none",
        },
        input: {
            padding: "1px",
            direction: "rtl",
        },
    })
);
interface Props {
    reportListParameter: any;
    getReportTemplateParameter: any;
    bookingId: any;
    reportData: any;
    createNewReport: any;
    updateReport: any;
    getUpdatedCustomerReportData: any;
    updateNiptDob: any;
    createNiptDob: any;
}
const NbsReport: React.FC<Props> = ({
    getReportTemplateParameter,
    reportListParameter,
    bookingId,
    reportData,
    createNewReport,
    updateReport,
    getUpdatedCustomerReportData,
    updateNiptDob,
    createNiptDob,
}) => {
    const componentRef = useRef<any>(null);
    const { firstP, secondP, thirdP } = useParams<any>();
    const classes = useStyles();
    const navigator = useNavigate();
    const [status, setStatus] = useState<string>(reportListParameter?.status);
    const [dob, setDob] = useState<any>("");
    const [age, setAge] = useState<any>("");
    const [Sample_Received, setSample_Received] = useState<any>("");
    const [Sample_Receivedtime, setSample_Receivedtime] = useState<any>("");
    const [Sample_Collected, setSample_Collected] = useState<any>("");
    const [designation, setdesignation] = useState<any>("");
    const [Name, setName] = useState<any>("");
    const [Gender, setGender] = useState<any>("");
    const [uuid, setUuid] = useState<any>("");
    const reactToPrintContent = React.useCallback(() => {
        return componentRef.current;
    }, [componentRef.current]);

    const reactToPrintTrigger = React.useCallback(() => {
        return (
            <button
                style={{ marginLeft: "10px", background: "#b02613", color: "white" }}
            >
                Print Report
            </button>
        );
    }, []);


    const [userInput, setUserInput] = useState("");

    const handleInputChange = (e: { target: { value: React.SetStateAction<string>; }; }) => {
        setUserInput(e.target.value);
    };


    //Report Data
    const [QfPcr, setQfPcr] = useState<any>([])
    useEffect(() => {
        const data: any = []
        if (reportListParameter && reportListParameter?.booking && reportListParameter?.booking.length > 0) {
            reportListParameter?.booking?.map((list: any) => {
                data?.push({ ...list });
            })
        }
        setQfPcr(data);
    }, [reportListParameter])


    useEffect(() => {
        if (thirdP !== "add") {
            getUpdatedCustomerReportData(`booking_id=${firstP}&template_id=${secondP}`)
        } else {
            getReportTemplateParameter(`booking_id=${firstP}&template_id=${secondP}`);
        }
    }, [])

    //Booking Data
    const [QfPcrReport, setQfPcrReport] = useState<any>([])
    useEffect(() => {
        const data: any = []
        if (reportListParameter && reportListParameter?.booking && reportListParameter?.booking.length > 0) {
            reportListParameter?.booking?.map((list: any) => {
                data?.push({ ...list });
            })
        }
        setQfPcrReport(data);
    }, [reportListParameter])

    useEffect(() => {
        setSample_Collected(QfPcrReport[0]?.collection_date);
        setSample_Receivedtime(QfPcrReport[0]?.pickup_time);
        setdesignation(QfPcrReport[0]?.designation);
        setGender(QfPcrReport[0]?.customer_gender);
        setSample_Received(QfPcrReport[0]?.pickup_date);
        setName(QfPcrReport[0]?.customer_name);
        setAge(QfPcrReport[0]?.customer_age);
        setDob(QfPcrReport[0]?.dob);
        setUuid(QfPcrReport[0]?.uuid);
    }, [QfPcrReport]);

    useEffect(() => {
        if (dob) {
            const currentDate = new Date();
            const dobDate = new Date(dob);
            const ageInMilliseconds = currentDate.getTime() - dobDate.getTime();
            const ageInYears = Math.floor(ageInMilliseconds / (1000 * 60 * 60 * 24 * 365));
            setAge(ageInYears);

        }
        else {

            setAge(QfPcrReport[0]?.customer_age);
        }
    }, [dob]);

    //CLINICAL INDICATIONS 
    const [QfPcrClinData, setQfPcrClinData] = useState<any>([]);
    useEffect(() => {
        const QfPcrclincdata: any = [];
        if (
            reportListParameter &&
            reportListParameter?.clinical_indication &&
            reportListParameter?.clinical_indication?.length > 0
        ) {
            reportListParameter?.clinical_indication?.map((list: any) => {
                QfPcrclincdata?.push({ ...list });
            });
        }
        setQfPcrClinData(QfPcrclincdata);
    }, [reportListParameter]);

    const updateClientIndication = (
        id: number,
        value: any,
        index: number,
        key: string,
        object: any) => {
        let storeData = [...QfPcrClinData]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value
                break;
        }
        storeData[index] = newItem;
        setQfPcrClinData(storeData);
    }


    // CLINICAL HISTORY

    const [QfPcrhistory, setQfPcrhistory] = useState<any>([]);
    useEffect(() => {
        const QfPcrhisto: any = [];
        if (
            reportListParameter &&
            reportListParameter?.clinical_significance
            &&
            reportListParameter?.clinical_significance
                ?.length > 0
        ) {
            reportListParameter?.clinical_significance
                ?.map((list: any) => {
                    QfPcrhisto?.push({ ...list });
                });
        }
        setQfPcrhistory(QfPcrhisto);
    }, [reportListParameter]);

    const updateclinicalHistory = (
        id: number,
        value: any,
        index: number,
        key: string,
        object: any) => {
        let storeData = [...QfPcrhistory]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value
                break;
        }
        storeData[index] = newItem;
        setQfPcrhistory(storeData);
    }

    // METHOD
    const [Method, setMethod] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.methodology
            &&
            reportListParameter?.methodology
                .length > 0
        ) {
            reportListParameter?.methodology
                ?.map((list: any) => {
                    data?.push({ ...list });
                });
        }
        setMethod(data);
    }, [reportListParameter]);

    const updateMethod = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...Method]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setMethod(storeData);
    }

    const [numPages, setNumPages] = useState<number>(0);

    //RESULT
    let Data = [
        {
            id: 1,
            name: "Trisomy 21 (Down’s Syndrome)",
            result: " Not Detected"
        },
        {
            id: 1,
            name: "Trisomy 18 (Edward’s Syndrome)",
            result: " Not Detected"
        },
        {
            id: 3,
            name: "Trisomy 13 (Patau’s Syndrome)",
            result: " Not Detected"
        },
        {
            id: 4,
            name: "Gonosomal Aneuploidy",
            result: "Not Detected"
        },
    ];
    const [QfPcrResult, setQfPcrResult] = useState([]);

    useEffect(() => {
        let storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.result_brca &&
            reportListParameter?.result_brca.length > 0
        ) {
            reportListParameter?.result_brca?.map((list: any) => {
                storeData.push({ ...list });
            });
        }
        setQfPcrResult(storeData);
    }, [reportListParameter]);

    const [tableData, setTableData] = useState<any>([]);
    useEffect(() => {
        let data: any;
        let parse: any;
        let storeData: any = [];
      
        const isValidJSON = (str: string) => {
          try {
            JSON.parse(str);
          } catch (e) {
            return false;
          }
          return true;
        };
      
        if (
          reportListParameter &&
          reportListParameter?.result_brca &&
          reportListParameter?.result_brca.length > 0
        ) {
          data = reportListParameter?.result_brca[0]?.parameter_value;
          if (data && isValidJSON(data)) {
            parse = JSON.parse(data);
          }
      
          if (parse?.length > 0) {
            parse?.forEach((list: any) => {
              storeData.push({ ...list });
            });
          } else {
            Data?.forEach((list: any) => {
              storeData.push({ ...list });
            });
          }
        }
        setTableData(storeData);
      }, [reportListParameter]);
      

    const updateRow = (index: number, key: string, value: any, object: any) => {
        let storeData = [...tableData];
        let newItem = storeData[index];
        switch (key) {
            case "name":
                newItem.name = value;
                break;
            case "result":
                newItem.result = value;
                break;

        }
        storeData[index] = newItem;
        setTableData(storeData);
    };

    // Result Remark
    const [QfPcrResultRemark, setQfPcrResultRemark] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.remarks2 &&
            reportListParameter?.remarks2.length > 0
        ) {
            reportListParameter?.remarks2?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setQfPcrResultRemark(data);
    }, [reportListParameter]);

    const updateResultRemark = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...QfPcrNote]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setQfPcrResultRemark(storeData);
    }

    //NOTE
    const [QfPcrNote, setQfPcrNote] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.remarks1 &&
            reportListParameter?.remarks1.length > 0
        ) {
            reportListParameter?.remarks1?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setQfPcrNote(data);
    }, [reportListParameter]);

    const updateNote = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...QfPcrNote]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setQfPcrNote(storeData);
    }

    // Interpretation
    const [QfPcrInterpretation, setQfPcrInterpretation] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.interpretation &&
            reportListParameter?.interpretation.length > 0
        ) {
            reportListParameter?.interpretation?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setQfPcrInterpretation(data);
    }, [reportListParameter]);

    const updateInterpretation = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...QfPcrInterpretation]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setQfPcrInterpretation(storeData);
    }

    // Hospital name
    const [hospitalName, setHospitalName] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.hospital_name &&
            reportListParameter?.hospital_name.length > 0
        ) {
            reportListParameter?.hospital_name?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setHospitalName(data);
    }, [reportListParameter]);

    const updateHospitalName = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...hospitalName]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setHospitalName(storeData);
    }

    //upload image 
    const [filePreviews, setFilePreviews] = useState<Array<string[]>>([]);

    const handleFileUpload = (files: any, index: any, list: any) => {
        const reader = new FileReader();

        reader.onload = () => {
            const fileContent = reader.result as string;
            const base64Image = fileContent.split(',')[1]; // Extract the base64 content

            // Add a file extension to base64Image
            const extension = 'jpg'; // Specify the desired file extension
            const base64ImageWithExtension = `data:image/${extension};base64,${base64Image}`;

            updateGraphData(list?.id, base64ImageWithExtension, index, 'free_text', list);

            // Update the file preview for the current index
            const updatedFilePreviews = [...filePreviews];
            if (!updatedFilePreviews[index]) {
                updatedFilePreviews[index] = []; // Initialize the array if it doesn't exist for the current index
            } else {
                updatedFilePreviews[index] = []; // Clear the previous file preview for the current index
            }

            // Create a base64 preview for display
            const readerForPreview = new FileReader();
            readerForPreview.onloadend = () => {
                const base64Preview = readerForPreview.result as string;
                setFilePreviews((prevPreviews) => {
                    const updatedPreviews = [...prevPreviews];
                    updatedPreviews[index] = [base64Preview];
                    return updatedPreviews;
                });
            };
            readerForPreview.readAsDataURL(files[0]);
        };

        reader.readAsDataURL(files[0]);
    };



    //graph 0
    const [bcrgraph, setGraph] = useState<any>([]);
    useEffect(() => {
        const bcrgraph: any = [];
        if (
            reportListParameter &&
            reportListParameter?.graph_image &&
            reportListParameter?.graph_image?.length > 0
        ) {
            reportListParameter?.graph_image?.map((list: any) => {
                bcrgraph?.push({ ...list });
            });
        }
        setGraph(bcrgraph);
    }, [reportListParameter]);

    const updateGraphData = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...bcrgraph]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setGraph(storeData);
    }


    //upload image 
    const [filePreviews1, setFilePreviews1] = useState<Array<string[]>>([]);

    const handleFileUpload1 = (files: any, index: any, list: any) => {
        const reader = new FileReader();

        reader.onload = () => {
            const fileContent = reader.result as string;
            const base64Image = fileContent.split(',')[1]; // Extract the base64 content

            // Add a file extension to base64Image
            const extension = 'jpg'; // Specify the desired file extension
            const base64ImageWithExtension = `data:image/${extension};base64,${base64Image}`;

            updateGraphData1(list?.id, base64ImageWithExtension, index, 'free_text', list);

            // Update the file preview for the current index
            const updatedFilePreviews = [...filePreviews];
            if (!updatedFilePreviews[index]) {
                updatedFilePreviews[index] = []; // Initialize the array if it doesn't exist for the current index
            } else {
                updatedFilePreviews[index] = []; // Clear the previous file preview for the current index
            }

            // Create a base64 preview for display
            const readerForPreview = new FileReader();
            readerForPreview.onloadend = () => {
                const base64Preview = readerForPreview.result as string;
                setFilePreviews1((prevPreviews) => {
                    const updatedPreviews = [...prevPreviews];
                    updatedPreviews[index] = [base64Preview];
                    return updatedPreviews;
                });
            };
            readerForPreview.readAsDataURL(files[0]);
        };

        reader.readAsDataURL(files[0]);
    };

    //graph 1
    const [bcrgraph1, setGraph1] = useState<any>([]);
    useEffect(() => {
        const bcrgraph1: any = [];
        if (
            reportListParameter &&
            reportListParameter?.graph_image1 &&
            reportListParameter?.graph_image1?.length > 0
        ) {
            reportListParameter?.graph_image1?.map((list: any) => {
                bcrgraph1?.push({ ...list });
            });
        }
        setGraph1(bcrgraph1);
    }, [reportListParameter]);

    const updateGraphData1 = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...bcrgraph1]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setGraph1(storeData);
    }


    //doctor list
    const [QfPcrdoctorList, setQfPcrdoctorList] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.doctor_list &&
            reportListParameter?.doctor_list.length > 0
        ) {
            reportListParameter?.doctor_list?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setQfPcrdoctorList(data);
    }, [reportListParameter]);

    const updateDoctorList = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...QfPcrdoctorList]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setQfPcrdoctorList(storeData);
    }

    //Clincian Name
    const [clinicianName, setClinicianName] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.clinical_name &&
            reportListParameter?.clinical_name.length > 0
        ) {
            reportListParameter?.clinical_name?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setClinicianName(data);
    }, [reportListParameter]);

    const updateClinicanName = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...clinicianName]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setClinicianName(storeData);
    }

    //Location
    const [locationName, setLocationName] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.location &&
            reportListParameter?.location.length > 0
        ) {
            reportListParameter?.location?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setLocationName(data);
    }, [reportListParameter]);

    const updateLocationName = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...locationName]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setLocationName(storeData);
    }

    // Hospital Id

    const [HospitalId, setHospitalId] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.Hospital_Id
            &&
            reportListParameter?.Hospital_Id

                .length > 0
        ) {
            reportListParameter?.Hospital_Id

                ?.map((list: any) => {
                    data?.push({ ...list });
                });
        }
        setHospitalId(data);
    }, [reportListParameter]);

    const updateHospitalID = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...HospitalId]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setHospitalId(storeData);
    }

    //Lmp date
    const [lmp, setlmp] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.lmp_date

            &&
            reportListParameter?.lmp_date

                .length > 0
        ) {
            reportListParameter?.lmp_date

                ?.map((list: any) => {
                    data?.push({ ...list });
                });
        }
        setlmp(data);
    }, [reportListParameter]);

    const updateLmp = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...lmp]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setlmp(storeData);
    }


    //Sample Type
    const [sampletype, setsampletype] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.sample_type
            &&
            reportListParameter?.sample_type
                .length > 0
        ) {
            reportListParameter?.sample_type
                ?.map((list: any) => {
                    data?.push({ ...list });
                });
        }
        setsampletype(data);
    }, [reportListParameter]);

    const updateSampletype = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...sampletype]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setsampletype(storeData);
    }

    //Submit Data

    const submitData = async (e: any) => {
        e.preventDefault();

        let storeData: any = [];

        if (QfPcrReport.length > 0) {
            QfPcrReport?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (QfPcrClinData.length > 0) {
            QfPcrClinData?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (QfPcrhistory.length > 0) {
            QfPcrhistory?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (Method.length > 0) {
            Method?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        if (QfPcrNote.length > 0) {
            QfPcrNote?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (QfPcrResultRemark.length > 0) {
            QfPcrResultRemark?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }


        if (QfPcrInterpretation.length > 0) {
            QfPcrInterpretation?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        if (bcrgraph.length > 0) {
            bcrgraph?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (bcrgraph1.length > 0) {
            bcrgraph1?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (QfPcrdoctorList.length > 0) {
            QfPcrdoctorList?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (QfPcr.length > 0) {
            QfPcr?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        if (hospitalName.length > 0) {
            hospitalName?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (clinicianName.length > 0) {
            clinicianName?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (locationName.length > 0) {
            locationName?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (HospitalId.length > 0) {
            HospitalId?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (lmp.length > 0) {
            lmp?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (sampletype.length > 0) {
            sampletype?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        const stringify = JSON.stringify(tableData);
        if (QfPcrResult.length > 0) {
            QfPcrResult?.map((list: any) => {
                storeData.push({
                    ...list,
                    parameter_value: stringify,
                });
            });
        }
        const reportData = {
            template_id: secondP,
            booking_id: firstP,
            case_id: firstP,
            template_parameter: storeData,
            dob: dob,
            status: status,
            customer_age: age,
            collection_date: Sample_Collected,
            pickup_date: Sample_Received,
            pickup_time: Sample_Receivedtime,
            customer_gender: Gender,
            customer_name: Name,
            designation: designation,
        };
        const reportEditData = {
            template_id: secondP,
            booking_id: firstP,
            case_id: firstP,
            status: status,
            template_parameter: storeData,
            dob: dob,
            customer_age: age,
            collection_date: Sample_Collected,
            pickup_date: Sample_Received,
            pickup_time: Sample_Receivedtime,
            customer_gender: Gender,
            customer_name: Name,
            designation: designation,
        };

        if (thirdP === "add") {
            await createNewReport(reportData);
            navigator('/dashboard/la');
        } else if (thirdP === "edit") {
            await updateReport(reportListParameter?.id, reportEditData);
            if (thirdP === "edit") {
                if (dob || age || Sample_Collected || Sample_Received || Sample_Receivedtime || Gender || designation || Name || status) {
                    await updateNiptDob(reportListParameter?.id, { dob, age, Sample_Collected, Sample_Received, Sample_Receivedtime, Gender, designation, Name, status });
                } else {
                    console.error("Missing dob value for updateNiptDob");
                }
            } else {
                await createNiptDob(reportListParameter?.id, {
                    dob, age, Sample_Collected, Sample_Received, Sample_Receivedtime, Gender, designation, Name, status
                });
            }
        }
    };
    const [isInputFocused, setInputFocused] = useState(false);

    const handleInputFocus = () => {
        setInputFocused(true);
    };

    const handleInputBlur = () => {
        setInputFocused(false);
    };

    const [uhid, setuhid] = useState<any>([]);
    const [tempCode, setTempCode] = useState<any>([]);
    useEffect(() => {
        setuhid(reportListParameter?.uhid)
        setTempCode(reportListParameter?.template_code)
    }, [reportListParameter])

    const documentTitle = `${QfPcrReport[0]?.pk}_${Name?.replace(/[\/\s]/g, '_')}_${uhid}_${tempCode}`;
    

    return (
        <Grammarly clientId="client_6FRQR4cCPSqwqzYEfgQCbq">
            <div style={{ margin: "55px auto" }}>
                <div>
                    <div style={{ height: "20px" }}>
                        <div>
                            {thirdP !== "add" && (
                                <ReactToPrint
                                    content={reactToPrintContent}
                                    trigger={reactToPrintTrigger}
                                    documentTitle={documentTitle}
                                />
                            )}
                        </div>
                    </div>
                    <div style={{ width: "200px", marginLeft: "780px" }}>
                        <TextField
                            id="outlined-select-currency"
                            select
                            variant="outlined"
                            fullWidth
                            className={classes.input}
                            label="Select Report Type"
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                            style={{ height: "30px" }}
                        >
                            <MenuItem value={"Draft"}>Draft</MenuItem>
                            <MenuItem value={"Editable"}>Editable</MenuItem>
                            <MenuItem value={"Approved"}>Approved</MenuItem>
                            <MenuItem value={"Hold"}>Hold</MenuItem>
                            <MenuItem value={"Cancelled"}>Cancelled</MenuItem>
                        </TextField>
                    </div>

                    <div style={{ height: "20px", marginLeft: "1000px", marginBottom: "20px" }}>
                        <div>
                            <button style={{ background: "#142c96", color: "white", width: "100px", height: "40px", marginTop: "-10px" }} disabled={status === ""} onClick={submitData}>Submit</button>
                        </div>
                    </div>
                </div>
                <div
                    id="PAGE"
                    ref={componentRef}
                    style={{
                        width: 1122,
                        background: "#fff",
                    }}
                >
                    {/* header section */}
                    <div className="Qfpcr-page-header">
                        <div style={{ padding: "20px" }}>
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    background: "#fff",
                                }}
                            >
                                <div style={{ width: "80%", padding: 15 }}>
                                    <div
                                        style={{
                                            color: "#1A5276",
                                            fontWeight: "bold",
                                            fontSize: "30px",
                                            textAlign: "left",
                                        }}
                                    >
                                        LABORATORY REPORT
                                    </div>
                                </div>
                                <div style={{ width: "20%", textAlign: "left", padding: 15 }}>
                                    <h3>
                                        <img src={logo} alt="logo" style={{ width: "200px" }} />
                                    </h3>
                                </div>
                                <div style={{ width: "13%", textAlign: "left", padding: 0 }}>
                                    <h3>
                                        <img src={mra} alt="logo" style={{ width: "90px",marginTop:"5px" }} />
                                    </h3>
                                </div>
                                {/* <div  style={{ width: "13%", textAlign: "left", padding: 0 }}>
                                    <div style={{ width: "13%", textAlign: "left", padding: 0 }}>
                                        <h3>
                                            <img src={nabllogo} alt="logo" style={{ width: "65px",marginTop:"5px" }} />
                                        </h3>
                                    </div>
                                    <div style={{ textAlign: "center", marginTop: "-8px" }}>
                                        <p style={{ fontSize: "16px", color: "#333", fontWeight: "bold",width:"70px" }}>MC-5280</p>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                    <div
                        style={{ width: "100%", textAlign: "center" }}
                        className="bcr_abl1"
                    >
                        <div
                            style={{

                                fontWeight: "bold",
                                fontSize: "40px",
                            }}
                            className="BCR"
                        >
                            <span style={{ fontWeight: "bold", color: "#400354" }}>QF-</span> <span style={{ fontWeight: "bold", color: "#750b1e" }}>PCR</span>
                        </div>
                    </div>
                    <br />

                    {/* <div className="Qfpcr-main-content3">.</div> */}
                    {/* patient details page 1 */}
                    <Paper style={{ backgroundColor: "#F8F8F8", width: "96%", marginLeft: "18px", marginTop: "13px", }}>
                        <Grid container spacing={2} style={{ fontWeight: "bold", fontSize: "15px", marginTop: "-20px" }} className="Qfpcr-marginLeft-c">
                            <Grid item xs={4}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            Patient ID
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {QfPcrReport[0]?.pk
                                                ? QfPcrReport[0]?.pk
                                                : "NA"}
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            Patient Name
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : <input
                                                className="input"
                                                style={{ border: "none", width: designation ? `${(designation.length + 1) * 8}px` : "20px", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                value={designation}
                                                onChange={(e) => setdesignation(e.target.value)}
                                            />
                                            <input
                                                className="input"
                                                style={{ border: "none", width: "70%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                value={Name}
                                                onChange={(e) => setName(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            Patient DOB
                                        </Grid><Grid item xs={8.5}>
                                            : <input
                                                className="input"
                                                style={{ border: "none", width: "65%", textAlign: "start", appearance: "none", background: "none", marginLeft: "2px", fontWeight: "bold" }}
                                                type="text"
                                                value={dob}
                                                placeholder={isInputFocused ? 'YYYY-MM-DD' : ''}
                                                onChange={(e) => {
                                                    setDob(e.target.value);
                                                }}
                                                onFocus={handleInputFocus}
                                                onBlur={handleInputBlur} />
                                        </Grid>
                                    </div>
                                </Grid>

                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            Age
                                        </Grid>
                                        {dob === "" || dob === null ? (
                                            <Grid item xs={8.5}>
                                                :<> <input
                                                        className="input"
                                                        style={{ border: "none", width: "12%", textAlign: "start", appearance: "none", background: "none", marginLeft: "2px", fontWeight: "bold" }}
                                                        type="text"
                                                        value={age}
                                                        onChange={(e) => setAge(e.target.value)} />Y
                                                    </>
                                                {/* {(QfPcrReport[0]?.customer_name.includes('Af') ||
                                                    QfPcrReport[0]?.customer_name.includes('AF') ||
                                                    QfPcrReport[0]?.customer_name.includes('CVS') ||
                                                    QfPcrReport[0]?.customer_name.includes('Cvs') ||
                                                    QfPcrReport[0]?.customer_name.includes('POC') ||
                                                    QfPcrReport[0]?.customer_name.includes('Poc') ||
                                                    QfPcrReport[0]?.customer_name.includes('FETUS') ||
                                                    QfPcrReport[0]?.customer_name.includes('Fetus') ||
                                                    QfPcrReport[0]?.customer_name.includes('F/O'))
                                                    ? 'NA'
                                                    : <> <input
                                                        className="input"
                                                        style={{ border: "none", width: "12%", textAlign: "start", appearance: "none", background: "none", marginLeft: "2px", fontWeight: "bold" }}
                                                        type="text"
                                                        value={age}
                                                        onChange={(e) => setAge(e.target.value)} />Y
                                                    </>
                                                } */}
                                            </Grid>
                                        ) : (
                                            <Grid item xs={8.5}>
                                                :
                                                {/* {(QfPcrReport[0]?.customer_name.includes('Af') ||
                                                    QfPcrReport[0]?.customer_name.includes('AF') ||
                                                    QfPcrReport[0]?.customer_name.includes('CVS') ||
                                                    QfPcrReport[0]?.customer_name.includes('Cvs') ||
                                                    QfPcrReport[0]?.customer_name.includes('POC') ||
                                                    QfPcrReport[0]?.customer_name.includes('Poc') ||
                                                    QfPcrReport[0]?.customer_name.includes('FETUS') ||
                                                    QfPcrReport[0]?.customer_name.includes('Fetus') ||
                                                    QfPcrReport[0]?.customer_name.includes('F/O'))
                                                    ? 'NA'
                                                    :
                                                    <span> {age} Y</span>

                                                } */}
                                                <span> {age} Y</span>
                                            </Grid>
                                        )
                                        }
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            GA/LMP Date
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            :{lmp?.map((list: any, index: number) => {
                                                return (
                                                    <input
                                                        style={{
                                                            border: "none",
                                                            width: "97%",
                                                            background: "none",
                                                            fontWeight: "bold",
                                                        }}
                                                        value={list?.parameter_value}
                                                        onChange={(e: any) => updateLmp(list?.id, e.target.value, index, "free_text", list)}
                                                    />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>
                            {/* rest half page---------------------------> */}
                            <Grid item xs={4.6}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Gender
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : 
                                            {/* {(QfPcrReport[0]?.customer_name.includes('Af') ||
                                                QfPcrReport[0]?.customer_name.includes('AF') ||
                                                QfPcrReport[0]?.customer_name.includes('CVS') ||
                                                QfPcrReport[0]?.customer_name.includes('Cvs') ||
                                                QfPcrReport[0]?.customer_name.includes('POC') ||
                                                QfPcrReport[0]?.customer_name.includes('Poc') ||
                                                QfPcrReport[0]?.customer_name.includes('FETUS') ||
                                                QfPcrReport[0]?.customer_name.includes('Fetus') ||
                                                QfPcrReport[0]?.customer_name.includes('F/O'))
                                                ? 'NA'
                                                : <input
                                                    className="input"
                                                    style={{ border: "none", width: "65%", textAlign: "start", appearance: "none", fontWeight: "bold", background: "none" }}
                                                    type="text"
                                                    value={Gender}
                                                    onChange={(e) => setGender(e.target.value)}
                                                />} */}
                                                <input
                                                    className="input"
                                                    style={{ border: "none", width: "65%", textAlign: "start", appearance: "none", fontWeight: "bold", background: "none" }}
                                                    type="text"
                                                    value={Gender}
                                                    onChange={(e) => setGender(e.target.value)}
                                                />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Clinician Name
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {clinicianName?.map((list: any, index: number) => {
                                                return (
                                                    <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateClinicanName(list?.id, e.target.value, index, "free_text", list)} />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Hospital Name
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {hospitalName?.map((list: any, index: number) => {
                                                return (
                                                    <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateHospitalName(list?.id, e.target.value, index, "free_text", list)} />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Location
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {locationName?.map((list: any, index: number) => {
                                                return (
                                                    <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateLocationName(list?.id, e.target.value, index, "free_text", list)} />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    {QfPcrReport[0]?.center?.name && QfPcrReport[0]?.center?.name.toUpperCase().includes("ARMC") ? (
                                        <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                            <Grid item xs={3.5}>
                                                Hospital ID
                                            </Grid>
                                            <Grid item xs={8.5}>
                                                : {HospitalId?.map((list: any, index: number) => {
                                                    return (
                                                        <input
                                                            key={list?.id}
                                                            style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }}
                                                            value={list?.parameter_value}
                                                            onChange={(e: any) => updateHospitalID(list?.id, e.target.value, index, "free_text", list)}
                                                        />
                                                    );
                                                })}
                                            </Grid>
                                        </div>
                                    ) : null}
                                </Grid>
                            </Grid>
                            {/* 3rd half  */}
                            <Grid item xs={3.4}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.3}>
                                            Sample Type
                                        </Grid>
                                        <Grid item xs={6.7}>
                                            : {sampletype?.map((list: any, index: number) => {
                                                return (
                                                    <select name="sample" id="1" style={{ border: "none", WebkitAppearance: "none", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e) => updateSampletype(list?.id, e.target.value, index, "free_text", list)}>
                                                        <option value="EDAT">Amniotic Fluid </option>
                                                        <option value="Venous">Chorionic Villi </option>
                                                        <option value="Arterial">Fetal Cord Blood</option>
                                                        <option value="Abortus">Product of Conception</option>
                                                        <option value="Placenta">Placenta</option>
                                                        <option value="Fetal">Fetal Cord (PUBS)</option>
                                                        <option value="Peripheral">Peripheral Blood</option>
                                                        <option value="Peripheral1">Pre Natal Cord </option>
                                                        <option value="dna">DNA</option>
                                                        <option value="blood">Blood</option>
                                                        <option value="whole blood edta"> Whole Blood EDTA </option>
                                                        <option value="tissue"> FFPE TISSUE BLOCK</option>
                                                        <option value="Bone Marrow">Bone Marrow</option>
                                                    </select>
                                                    // <input style={{ border: "none", width: "94%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateSampletype(list?.id, e.target.value, index, "free_text", list)} />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.3}>
                                            Sample Collected
                                        </Grid>
                                        <Grid item xs={6.7}>
                                            : <input
                                                className="input"
                                                style={{ border: "none", width: "75%", textAlign: "start", appearance: "none", fontWeight: "bold", background: "none" }}
                                                type="text"
                                                placeholder="yyyy-mm-dd"
                                                pattern="\d{4}-\d{2}-\d{2}"
                                                value={Sample_Collected}
                                                onChange={(e) => setSample_Collected(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.3}>
                                            Sample Received
                                        </Grid>
                                        <Grid item xs={6.7}>
                                            : <input
                                                className="input"
                                                style={{ border: "none", width: "52%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                placeholder="yyyy-mm-dd"
                                                value={Sample_Received}
                                                onChange={(e) => setSample_Received(e.target.value)}
                                            />,
                                            <input
                                                className="input"
                                                style={{ border: "none", width: "40%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                placeholder="HH:MM:SS"
                                                value={Sample_Receivedtime}
                                                onChange={(e) => setSample_Receivedtime(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.3}>
                                            Report Released
                                        </Grid>
                                        <Grid item xs={6.7}>
                                            : {moment.tz(Date.now(), "Asia/Kolkata").format("YYYY-MM-DD,HH:mm:ss")}
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>

                        </Grid>
                    </Paper>
                    <div style={{ width: "95%", marginLeft: "24px" }}>
                        <h6 style={{ backgroundColor: "rgb(22 55 88)", color: "white", textAlign: "center", borderBottomLeftRadius: "15px", borderBottomRightRadius: "15px", height: "35px", marginTop: "-1px", padding: "8px" }}>Test Performed:-{QfPcrReport[0]?.packages[0]?.name}</h6>
                    </div>
                    <div className="Qfpcr-br">.</div>
                    {/* Clinical History */}
                    {/* <div className="Qfpcr-clinical__indicatio" >
                        <span className="Qfpcr-clinical__subheadin" style={{ padding: "0px 10px 0px 43px" }}> CLINICAL HISTORY </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div>
                        {QfPcrhistory?.map((list: any, index: number) => {
                            return (
                                <div style={{ padding: 15, textAlign: "left", marginTop: "-7px", fontSize: "17px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none", marginLeft: "32px" }}
                                            rows={3}
                                            cols={118}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateclinicalHistory(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            )
                        })}
                    </div>
                    <div className="Qfpcr-br">.</div> */}
                    {/* clinical indication  */}
                    <div className="Qfpcr-clinical__indicatio" >
                        <span className="Qfpcr-clinical__subheadin" style={{ padding: "0px 10px 0px 43px" }}> CLINICAL INDICATION / HISTORY</span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div>
                        {QfPcrClinData?.map((list: any, index: number) => {
                            return (
                                <div style={{ padding: 15, textAlign: "left", marginTop: "-7px", fontSize: "17px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none", marginLeft: "32px" }}
                                            rows={6}
                                            cols={118}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateClientIndication(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            )
                        })}
                    </div>
                    <div className="Qfpcr-br">.</div>
                    {/* results  */}
                    <div className="Qfpcr-clinical__indicatio" style={{ marginTop: "-16px" }}>
                        <span className="Qfpcr-clinical__subheadin" style={{ padding: "0px 10px 0px 43px" }}>RESULT</span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div className="contain" style={{ border: "none", width: "90%", marginLeft: "40px", backgroundColor: "white", padding: 8 }}>

                        {QfPcrResultRemark?.map((list: any, index: number) => {
                            const value = list?.parameter_value || "";
                            const isTrisomy = value.includes("Trisomy");
                            const isGonosomal = value.includes("Gonosomal");
                            const color = isTrisomy || isGonosomal ? "red" : "black";
                            return (
                                <div style={{ width: "100%", fontSize: "17px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            cols={116}
                                            rows={2}
                                            style={{ color: color, border: "none", resize: "none" }}
                                            value={list?.parameter_value}
                                            onChange={(e) =>
                                                updateResultRemark(
                                                    list?.id,
                                                    e.target.value,
                                                    index,
                                                    "free_text",
                                                    list
                                                )
                                            }
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            );
                        })}
                    </div>
                    {/* <div className="Qfpcr-br">.</div> */}
                    <div className="Qfpcr-clinical__indicatio" style={{ marginTop: "-16px" }}>
                        <span className="Qfpcr-clinical__subheadin" style={{ padding: "0px 10px 0px 43px" }}>SYNDROMES TABLE</span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div style={{ width: "93%", border: "1px solid gray", marginLeft: "40px", height: "40px" }}>
                        <div style={{ display: "flex", background: "#e8eded", color: "  rgb(5, 57, 110)", fontWeight: "bolder", fontSize: "18px", height: "40px" }}>
                            <p style={{ width: "50%", textAlign: "center", borderRight: "1px solid gray", height: "40px", }}>List of Syndromes Aneuploidy</p>
                            <p style={{ width: "47%", textAlign: "center" }}>Aneuploidy</p>
                        </div>
                    </div>
                    <div>
                        <div className="contain" style={{ border: "1px solid gray", width: "93%", marginLeft: '40px' }} >
                            {tableData?.length > 0 &&
                                tableData?.map((list: any, index: number) => {
                                    return (
                                        <>
                                            <div
                                                style={{
                                                    width: "100%",
                                                    display: "flex",
                                                    fontSize: "14px",
                                                    height: "40px",
                                                }}

                                            >
                                                <div style={{ width: "50%", borderRight: "1px solid gray", borderBottom: "1px solid gray" }}>
                                                    <input
                                                        style={{ border: "none", width: "95%", background: "none", textAlign: "center", margin: "6px" }}
                                                        value={list?.name}
                                                        onChange={(e: any) =>
                                                            updateRow(index, "name", e.target.value, list)

                                                        }
                                                    />
                                                </div>
                                                {
                                                    list?.risk !== "green" ?
                                                        <div
                                                            style={{ width: "50%", textAlign: "left", borderBottom: "1px solid gray" }}
                                                        >
                                                            <input
                                                                style={{ color: list?.result === "Detected" ? "red" : "black", border: "none", width: "95%", background: "none", marginTop: "7px", textAlign: "center" }}
                                                                value={list?.result}
                                                                onChange={(e: any) =>
                                                                    updateRow(index, "result", e.target.value, list)
                                                                }
                                                            />
                                                        </div> :
                                                        <div
                                                            style={{ width: "45%", marginLeft: 8, textAlign: "left" }}
                                                        >
                                                        </div>
                                                }
                                            </div>

                                        </>
                                    );
                                })}
                        </div>
                    </div>
                    <br />
                    {/* <div className="Qfpcr-br">.</div> */}
                    {/* <div className="Qfpcr-br">.</div> */}
                    {/* doctor sign  */}
                    <div style={{ width: "89%", display: 'flex', padding: 0, margin: 0, justifyContent: 'space-around', marginTop: "-10px" }}>
                        {QfPcrdoctorList && QfPcrdoctorList?.length > 0 && QfPcrdoctorList?.filter((doctor: any) => doctor?.parameter_url !== "")?.map((list: any, index: number) => {
                            return (
                                <>
                                    <img
                                        alt="description of image"
                                        style={{ width: "100px", height: "50px", marginLeft: "85px" }}
                                        src={list?.parameter_url}
                                    />
                                </>
                            )
                        })}
                    </div>
                    <div style={{ width: "97%", display: 'flex', alignItems: 'left', marginLeft: "18px" }}>
                        {QfPcrdoctorList && QfPcrdoctorList?.length > 0 && QfPcrdoctorList?.filter((doctor: any) => doctor?.parameter_url !== "")?.map((list: any, index: number) => {
                            return (
                                <>
                                    <textarea
                                        style={{ border: "none", resize: "none", textAlign: "center" }}
                                        rows={4}
                                        cols={140}
                                        value={list?.parameter_value}
                                        onChange={(e) => updateDoctorList(list?.id, e.target.value, index, "free_text", list)}
                                    />
                                </>
                            )
                        })}
                    </div>

                    <div className="Qfpcr-main-content2">.</div>
                    <div className="Qfpcr-main-content4">.</div>

                    <div
                        style={{
                            fontWeight: "bold",
                            fontSize: "15px",
                            borderTopRightRadius: "20px",
                            borderBottomRightRadius: "20px",
                            background: "rgb(238, 238, 238)",
                            textAlign: "left",
                            marginTop: "20px",
                            // width: "600px",
                            width: "80%",
                            maxWidth: "800px",
                            height: "40px",
                            padding: "10px",
                            paddingLeft: "40px",
                            borderRight: "1px solid rgb(22 55 88)",
                            borderBottom: "1px solid rgb(22 55 88)",
                            borderTop: "1px solid rgb(22 55 88)"
                        }}
                        className="Qfpcr-marginleft-b">
                        Patient Name:&nbsp;&nbsp;{QfPcrReport[0]?.designation}&nbsp;{QfPcrReport[0]?.customer_name}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Patient Id:&nbsp;&nbsp;{QfPcrReport[0]?.pk}
                    </div>
                    <div className="Qfpcr-br">.</div>
                    <div className="Qfpcr-clinical__indicatio" >
                        <span
                            className="Qfpcr-clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            NOTE
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div>
                        {QfPcrNote.map((list: any, index: number) => {
                            return (
                                <div style={{ width: "45%", padding: 15, textAlign: "left", fontSize: "17px", marginLeft: "35px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ fontWeight: "bold", border: "none", resize: "none" }}
                                            rows={4}
                                            cols={116}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateNote(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            );
                        })}
                    </div>
                    {/* methology  */}
                    <div className="Qfpcr-clinical__indicatio" style={{ marginTop: "-16px" }}>
                        <span
                            className="Qfpcr-clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            INTERPRETATION
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div>
                        {QfPcrInterpretation.map((list: any, index: number) => {
                            return (
                                <div style={{ width: "45%", padding: 15, textAlign: "left", fontSize: "17px", marginLeft: "35px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none" }}
                                            rows={4}
                                            cols={116}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateInterpretation(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            );
                        })}
                    </div>
                    <div className="Qfpcr-clinical__indicatio" style={{ marginTop: '-16px' }} >
                        <span
                            className="Qfpcr-clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            ELECTROPHORETOGRAM
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />

                    {/* upload image  */}
                    <div style={{ display: "flex", marginTop: "-20px" }}>
                        <>
                            <div>
                                {bcrgraph.map((list: any, index: number) => {
                                    return (
                                        <div
                                            key={index}
                                            style={{ width: "90%", padding: 15, textAlign: "left", fontSize: "14px", marginLeft: "35px" }}
                                        >
                                            {/* Display base64-encoded image */}
                                            {
                                                thirdP === 'edit' && list.parameter_type === 'free_text' && list.parameter_name === 'garph13' && list.parameter_value && list.parameter_value.startsWith('data:image/') && (
                                                    <div>
                                                        <img
                                                            src={list.parameter_value}
                                                            alt={`Image ${index}`}
                                                            style={{ width: '100%', maxHeight: "550px" }}
                                                        />
                                                    </div>
                                                )
                                            }
                                            {/* Display file previews */}
                                            {index === 0 && filePreviews[index] && (
                                                <div>
                                                    {filePreviews[index].map((preview: string, previewIndex: number) => (
                                                        <img
                                                            key={previewIndex}
                                                            src={preview}
                                                            alt={`File Preview ${previewIndex + 1}`}
                                                            style={{ width: "100%", maxHeight: "550px" }}
                                                        />
                                                    ))}
                                                </div>
                                            )}
                                            {thirdP === "edit" ? "" :
                                                <input
                                                    type="file"
                                                    onChange={(e) => handleFileUpload(e.target.files, index, list)}
                                                />}
                                        </div>
                                    );
                                })}
                            </div>
                            <div>
                                {bcrgraph1.map((list: any, index: number) => {
                                    return (
                                        <div
                                            key={index}
                                            style={{ width: "90%", padding: 15, textAlign: "left", fontSize: "14px", marginLeft: "35px" }}
                                        >
                                            {/* Display base64-encoded image */}
                                            {
                                                thirdP === 'edit' && list.parameter_type === 'free_text' && list.parameter_name === 'image6' && list.parameter_value && list.parameter_value.startsWith('data:image/') && (
                                                    <div>
                                                        <img
                                                            src={list.parameter_value}
                                                            alt={`Image ${index}`}
                                                            style={{ width: '100%', maxHeight: "550px" }}
                                                        />
                                                    </div>
                                                )
                                            }
                                            {/* Display file previews */}
                                            {index === 0 && filePreviews1[index] && (
                                                <div>
                                                    {filePreviews1[index].map((preview: string, previewIndex: number) => (
                                                        <img
                                                            key={previewIndex}
                                                            src={preview}
                                                            alt={`File Preview ${previewIndex + 1}`}
                                                            style={{ width: "100%", maxHeight: "550px" }}
                                                        />
                                                    ))}
                                                </div>
                                            )}
                                            {thirdP === "edit" ? "" :
                                                <input
                                                    type="file"
                                                    onChange={(e) => handleFileUpload1(e.target.files, index, list)}
                                                />}
                                        </div>
                                    );
                                })}
                            </div>
                        </>
                    </div>

                    <div className="Qfpcr-br">.</div>
                    {/* doctor sign  */}
                    <div style={{ width: "89%", display: 'flex', padding: 0, margin: 0, justifyContent: 'space-around', marginTop: "-10px" }}>
                        {QfPcrdoctorList && QfPcrdoctorList?.length > 0 && QfPcrdoctorList?.filter((doctor: any) => doctor?.parameter_url !== "")?.map((list: any, index: number) => {
                            return (
                                <>
                                    <img
                                        alt="description of image"
                                        style={{ width: "100px", height: "50px", marginLeft: "85px" }}
                                        src={list?.parameter_url}
                                    />
                                </>
                            )
                        })}
                    </div>
                    <div style={{ width: "97%", display: 'flex', alignItems: 'left', marginLeft: "18px" }}>

                        {QfPcrdoctorList && QfPcrdoctorList?.length > 0 && QfPcrdoctorList?.filter((doctor: any) => doctor?.parameter_url !== "")?.map((list: any, index: number) => {
                            return (
                                <>
                                    <textarea
                                        style={{ border: "none", resize: "none", textAlign: "center" }}
                                        rows={4}
                                        cols={140}
                                        value={list?.parameter_value}
                                        onChange={(e) => updateDoctorList(list?.id, e.target.value, index, "free_text", list)}
                                    />
                                </>
                            )
                        })}
                    </div>
                    <div className="Qfpcr-main-content2">.</div>
                    <div className="Qfpcr-main-content4">.</div>

                    <div
                        style={{
                            fontWeight: "bold",
                            fontSize: "15px",
                            borderTopRightRadius: "20px",
                            borderBottomRightRadius: "20px",
                            background: "rgb(238, 238, 238)",
                            textAlign: "left",
                            marginTop: "20px",
                            // width: "600px",
                            width: "80%",
                            maxWidth: "800px",
                            height: "40px",
                            padding: "10px",
                            paddingLeft: "40px",
                            borderRight: "1px solid rgb(22 55 88)",
                            borderBottom: "1px solid rgb(22 55 88)",
                            borderTop: "1px solid rgb(22 55 88)"

                        }}
                        className="marginleft-b">
                        Patient Name:&nbsp;&nbsp;{QfPcrReport[0]?.designation}&nbsp;{QfPcrReport[0]?.customer_name}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Patient Id:&nbsp;&nbsp;{QfPcrReport[0]?.pk}
                    </div>
                    <div className="Qfpcr-clinical__indicatio" >
                        <span className="Qfpcr-clinical__subheadin" style={{ padding: "0px 10px 0px 43px" }}>METHOD </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div className="contain" style={{ border: "none", width: "90%", marginLeft: "40px", backgroundColor: "white", padding: 8 }}>

                        {Method?.map((list: any, index: number) => {
                            return (
                                <div style={{ width: "100%", fontSize: "17px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            cols={118}
                                            rows={4}
                                            style={{ border: "none", resize: "none" }}
                                            value={list?.parameter_value}
                                            onChange={(e) =>
                                                updateMethod(
                                                    list?.id,
                                                    e.target.value,
                                                    index,
                                                    "free_text",
                                                    list
                                                )
                                            }
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            );
                        })}
                    </div>
                    <div className="Qfpcr-clinical__indicatio" >
                        <span
                            className="Qfpcr-clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            TECHNOLOGY
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div style={{ width: "95%", marginLeft: "50px", fontSize: "17px" }}>
                        <p>
                            Quantitative fluorescence PCR (QF-PCR) is a reliable molecular method for rapid aneuploidy diagnosis. DNA was isolated from the given
                            sample using a commercial kit according to manufacturer’s instructions. Multiplex PCR amplification of short tandem repeat (STR) markers
                            using fluorescent tagged primer was carried out using a commercial kit according to manufacturer’s instructions. The resulting fragments
                            were analysed on the genetic analyser for visualization and quantification. The copy number of respective chromosome is quantified by
                            calculating the relative allele ratio. Analysed region includes: D13S634, D13S305, D13S800, D13S628, D13S252, D18S386, D18S978,
                            D18S390, D18S819, D18S535, D21S11, D21S1437, D21S1409, D21S1435, D21S1442, D21S1446, DXS6803, DXS1187, XHPRT,
                            AMELX/Y, DXYS218, TAF9L and SRY.
                        </p>
                    </div>
                    {/* limitations of assay  */}
                    <div className="Qfpcr-clinical__indicatio" >
                        <span
                            className="Qfpcr-clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            REPORTING & LIMITATIONS
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div style={{ width: "97%" }}>
                        <ol style={{ marginLeft: "30px", fontSize: "17px" }}>
                            <li>
                                Detection of structural chromosomal abnormalities including but not limited to balanced and unbalanced translocations is not possible
                                by QF- PCR.

                            </li>
                            <li>
                                Sensitivity and specificity of the assay may be influenced by the quality of the specimens received at the laboratory.
                            </li>
                            <li>
                                Samples with significant mosaicism and maternal cell contamination may impact the diagnostic accuracy of QF-PCR.
                            </li>
                        </ol>
                    </div>
                    <div className="Qfpcr-clinical__indicatio" >
                        <span className="Qfpcr-clinical__subheadin" style={{ padding: "0px 10px 0px 45px", fontSize: "20px" }}>DISCLAIMER</span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />

                    <div className="container" style={{ border: "none", width: "95%", backgroundColor: "white", marginLeft: "12px", fontSize: "17px" }}>
                        <ol>
                            <li>
                                <p>The given test result should be interpreted in context of all available clinical findings. </p>
                            </li>
                            <li>
                                <p>As per the PRE-NATAL DIAGNOSTIC TECHNIQUES (REGULATIONS & PREVENTION OF MISUSE) AMENDMENT ACT 2002, sex determination shall not be done for all prenatal samples.</p>
                            </li>
                        </ol>


                    </div>
                    <div className="Qfpcr-clinical__indicatio" >
                        <span className="Qfpcr-clinical__subheadin" style={{ padding: "0px 10px 0px 45px", fontSize: "20px" }}>REFERENCE</span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div className="Qfpcr-contain" style={{ border: "none", width: "95%", backgroundColor: "white", marginLeft: "40px", fontSize: '17px' }}>

                        <p>American College of Medical Genetics-Standards and Guidelines for Clinical Genetics Laboratories, 2006 Edition. </p>
                        <p>Schrijver, I., Cherny, S.C., and Zehnder, J.L. Testing for Maternal Cell Contamination in Prenatal Samples. Journal of Molecular Diagnostics 2007, 9(3):394-400.</p>
                        <p>  Stoiilkovic-Mikic, T., Mann, K., Docherty, Z., and Oqilivie, C.M. Maternal cell contamination of prenatal samples assessed by QF-PCR genotyping. Prenatal Diagnosis 2005,25(1):79-83. </p>
                    </div>
                    <p style={{ color: "white", backgroundColor: "#e30b2c", textAlign: "center", marginTop: "20px", width: "95%", marginLeft: "30px" }}>Important: On doing PNDT test, the undersigned hereby confirms that no sex chromosome information has been passed on to anyone in
                        whatsoever manner.</p>
                    <div style={{ width: "80%", marginLeft: "60px", textAlign: "center", marginTop: "20px" }}><h5>Disclaimer- The sample is processed at the PC-PNDT certified laboratory</h5></div>
                    {/* <div className="main-content3">.</div> */}
                    {/* doctor sign  */}
                    <div style={{ width: "89%", display: 'flex', padding: 0, margin: 0, justifyContent: 'space-around', marginTop: "30px" }}>
                        {QfPcrdoctorList && QfPcrdoctorList?.length > 0 && QfPcrdoctorList?.filter((doctor: any) => doctor?.parameter_url !== "")?.map((list: any, index: number) => {
                            return (
                                <>
                                    <img
                                        alt="description of image"
                                        style={{ width: "100px", height: "50px", marginLeft: "85px" }}
                                        src={list?.parameter_url}
                                    />
                                </>
                            )
                        })}
                    </div>
                    <div style={{ width: "97%", display: 'flex', alignItems: 'left', marginLeft: "18px" }}>

                        {QfPcrdoctorList && QfPcrdoctorList?.length > 0 && QfPcrdoctorList?.filter((doctor: any) => doctor?.parameter_url !== "")?.map((list: any, index: number) => {
                            return (
                                <>
                                    <textarea
                                        style={{ border: "none", resize: "none", textAlign: "center" }}
                                        rows={4}
                                        cols={140}
                                        value={list?.parameter_value}
                                        onChange={(e) => updateDoctorList(list?.id, e.target.value, index, "free_text", list)}
                                    />
                                </>
                            )
                        })}
                    </div>
                    {/* patient details page 2 end */}

                    {/* footer section starting */}
                    <div className="Qfpcr-page-footer">
                        {/* footer area */}
                        <div style={{ padding: "20px" }}>
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    background: "#fff",
                                }}
                            >
                                <div style={{ width: "15%", textAlign: "left", padding: 15 }}>
                                    <h3>
                                        <QRCode value={`https://lead.redcliffelabs.com/verify-report/?booking=${uuid}&api_key=pvkbv24f916fa28-dd38-4ba5-ad6c-8a78d0`} size={110} />
                                    </h3>
                                </div>
                                <div
                                    style={{
                                        width: "85%",
                                        textAlign: "left",
                                        padding: 10,
                                        marginTop: "-3px",
                                    }}
                                >
                                    <div
                                        style={{ width: "100%", display: "flex", margin: "10px 0px" }}
                                    >
                                        <div style={{ width: "33%", marginLeft: 8 }}>
                                            <img
                                                src={callIcon}
                                                alt="logo"
                                                style={{ width: "20px", margin: "2px" }}
                                            />{" "}
                                            <span style={{ color: "red" }}>
                                                <b>931-126-1989</b>
                                            </span>
                                        </div>
                                        <div style={{ width: "33%", marginLeft: 8 }}>
                                            <img
                                                src={maillIcon}
                                                alt="logo"
                                                style={{ width: "20px", margin: "2px" }}
                                            />
                                            <span style={{ color: "red" }}>
                                                <b>genee@redcliffelabs.com</b>
                                            </span>
                                        </div>
                                        <div style={{ width: "33%", marginLeft: "68px" }}>
                                            <img
                                                src={browserIcon}
                                                alt="logo"
                                                style={{ width: "20px", margin: "2px" }}
                                            />
                                            <span style={{ color: "red" }}>
                                                <b>www.redcliffelabs.com</b>
                                            </span>
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            margin: "10px 0px",
                                            textAlign: "left",
                                        }}
                                    >
                                        <h5 style={{ marginLeft: "16px" }}>
                                            {" "}
                                            <b>
                                                Redcliffe Lifetech Pvt. Ltd, H-31, Sector- 63, Noida,
                                                Uttar Pradesh, 201301
                                            </b>
                                        </h5>
                                    </div>
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            margin: "10px 0px",
                                            marginLeft: "16px",
                                            textAlign: "left",
                                        }}
                                    >
                                        <p style={{ fontSize: "13px", marginTop: "-8px" }}>
                                            {" "}
                                            All Lab are subjected to clinical interpretations by
                                            qualified medical professional and this report is not
                                            subject to use for any medico-legal purpose.
                                        </p>
                                    </div>
                                    <hr
                                        style={{
                                            backgroundColor: "red",
                                            width: "100%",
                                            height: "8px",
                                            marginTop: "10px",
                                        }}
                                        className="Qfpcr-box"
                                    />
                                </div>
                            </div>
                        </div>
                        {/* footer area closed */}
                    </div>
                                        {
                                                uuid && (
                                                    <div className="hide-section-rating">
                                                        <NpsRating bookingId={firstP} uuid={uuid} />
                                                    </div>
                                                )
                                            }
                </div>
            </div >
        </Grammarly>
    );
};
const mapStateToProps = (state: any) => ({
    reportListParameter: state.LimsAdminReducer.reportListParameter,
});

export default connect(mapStateToProps, {
    getReportTemplateParameter,
    createNewReport,
    updateReport,
    getUpdatedCustomerReportData,
    updateNiptDob,
    createNiptDob,
})(NbsReport);

function setInputValues(arg0: (prevState: any) => any) {
    throw new Error("Function not implemented.");
}